import { ClaimSaveUseCase } from '../../../application';

export default class ClaimSaveService {
    constructor() {}

    async execute(event) {
        const request = await ClaimSaveUseCase(event);

        return request;
    }
}
